import { IComponentOptions } from 'angular';
import { GradPlanningWizardCtrl } from './grad-planning-wizard.controller';

export const GradPlanningWizardComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentUser: '<',
    initialWizardState: '<',
  },
  controller: GradPlanningWizardCtrl,
  template: require('./grad-planning-wizard.html'),
};
